import { Component, Input, OnChanges } from '@angular/core';
import { handlingUnitLocation, HandlingUnitMasterDTO } from '../../../models/handling-unit-master';
import { groupUnitRows, LotUnitRow } from '../lot-unit-summary';

@Component({
  selector: 'lot-location-summary',
  templateUrl: './lot-location-summary.component.html'
})
export class LotLocationSummaryComponent implements OnChanges {
  @Input() allHandlingUnits: HandlingUnitMasterDTO[] = [];
  @Input() lotId: number;

  public rows: LotUnitRow[] = [];

  ngOnChanges() {
    this.rows = groupUnitRows(this.allHandlingUnits ?? [],
      hum => handlingUnitLocation(hum) || 'Unknown',
      hum => (hum.handlingUnitDetails ?? []).filter(hud => hud.lotId == this.lotId));
  }
}
